import { createRoute, defer } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { CompanyAccountErrorComponent, CompanyAccountSkeleton } from './account/companyAccountLayout'
import { organizationsQueryOptions } from './api/master-data.service'
import { Documents } from './documents/documents'
import { Users } from './users/users'

export const companyUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/users',
  beforeLoad: ensureAuthenticatedUser,
  component: Users,
})

export const companyDocumentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/documents',
  beforeLoad: ensureAuthenticatedUser,
  component: Documents,
})

export const companyAccountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/account',
  errorComponent: CompanyAccountErrorComponent,
  pendingComponent: CompanyAccountSkeleton,
  beforeLoad: ensureAuthenticatedUser,
  loader: async ({ context }) => {
    if (!context.queryClient) return
    const customerID = context.initialData?.customer?._id || ''
    const organizations = context.queryClient?.ensureQueryData(organizationsQueryOptions(customerID))
    return { organizations: defer(organizations) }
  },
}).lazy(() => import('./account/companyAccount').then((d) => d.Route))
